import React, {FC} from "react";
import {TipTapEditor} from "../../TipTapEditor";
import {DocPageVersion} from "../DocumentPageHeader";

export const VersionHistoryPreviewModal: FC<{ version: DocPageVersion }> = (props) => {
  return <div className={"overflow-y-scroll"}>
    <TipTapEditor showMenuBar={false} editable={false} title={`Versie ${props.version.version}`} lastEdited={props.version.createdAt} content={props.version.content} setContent={() => {}} />
  </div>
}